import { render, staticRenderFns } from "./DAdminIntegrations.vue?vue&type=template&id=58aac79e&scoped=true&"
import script from "./DAdminIntegrations.vue?vue&type=script&lang=js&"
export * from "./DAdminIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./DAdminIntegrations.vue?vue&type=style&index=0&id=58aac79e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aac79e",
  null
  
)

export default component.exports